<template>
  <div>
    <Drawer
      ref="modal"
      v-model="showModal"
      width="85%"

      :closable="true"
      @on-close="onDrawerClose"
    >
      <div slot="header" style="padding: 0 10px;">
        <span style="font-size: 16px;line-height: 22px;">
          {{ modalTitle }}
        </span>
      </div>
      <Tabs v-model="tabsValue">
        <TabPane class="tab-content" label="其他课程学生" name="name1">
          <EnrollStudentModalItemNew
            ref="EnrollStudentModalItem"
            v-model="unCheckStuInfo"
            :show-modal="showModal"
            :classroom-id="classroomIdItem"
            :rel-classroom-id="relClassroomIdItem"
            :school-id="schoolIdItem"
            :class-time-lists="classTimeLists"
            :start-date="
              selectStudentRow.classDateBegin
                ? selectStudentRow.classDateBegin
                : ''
            "
            :year-code="yearCode"
            :term-code="termCode"
            @close="close"
            @btn-status="handleStuItemNewBtnStatus"
            @refreshCurrentPageList="refreshCurrentPageList"
            @resetRemoveStudent="resetRemoveStudent"
          ></EnrollStudentModalItemNew>
        </TabPane>
        <TabPane class="tab-content" label="已选该课程学生" name="name2">
          <div>
            <div class="modal-content">
              <div class="left-table">
                <!-- 搜索框部分 start  -->
                <div class="search-block">
                  <Form
                    ref="searchForm"
                    :model="searchFormValidate"
                    label-position="right"
                    inline
                  >
                    <Row>
                      <FormItem prop="studentName">
                        <Input
                          v-model="searchFormValidate.studentName"
                          placeholder="学生姓名"
                        ></Input>
                      </FormItem>

                      <FormItem prop="classData">
                        <Cascader
                          v-model="searchFormValidate.classData"
                          style="width: 240px; margin-right: 10px"
                          :data="gradeAndClassList"
                          change-on-select
                          placeholder="请选择年级班级"
                        ></Cascader>
                      </FormItem>

                      <FormItem prop="studentSts">
                        <Select
                          v-model="searchFormValidate.studentSts"
                          style="width: 120px"
                          placeholder="入班状态"
                        >
                          <Option
                            v-for="item in inClassStatusList"
                            :key="item.value"
                            :value="item.value"
                          >{{ item.label }}</Option>
                        </Select>
                      </FormItem>

                      <FormItem prop="gender">
                        <Select
                          v-model="searchFormValidate.gender"
                          clearable
                          style="width: 100px"
                          placeholder="性别"
                        >
                          <Option value="1">男</Option>
                          <Option value="2">女</Option>
                        </Select>
                      </FormItem>
                      <FormItem>
                        <CascaderYearTerms
                          v-if="cacheYearTerms.length === 2&&showModal"
                          class="term-block"
                          :cache-year-terms="cacheYearTerms"
                          :disabled-year-term="true"
                        >
                        </CascaderYearTerms>
                      </FormItem>
                      <!-- <Col span="3" style="margin-left: 10px"> -->
                      <Button
                        class="search-btn"
                        type="primary"
                        style="margin-bottom: 24px;"
                        @click="handleSearch"
                      >搜索</Button>
                      <Button style="margin-bottom: 24px;" @click="resetForm">重置</Button>
                      <!-- <span class="click-btn-430" @click="resetForm"
                          >重置筛选条件</span
                        > -->
                      <!-- </Col> -->
                    </Row>
                  </Form>
                </div>
                <!-- 搜索框部分 end  -->
                <!-- 学生列表表格 start  -->
                <div class="table-box">
                  <Table
                    ref="dataTable"
                    border
                    :columns="tableColumn"
                    :data="studentList"
                    max-height="600"
                    :loading="tableLoading"
                    @on-row-click="selectRow"
                    @on-select="pickOneStudent"
                    @on-select-cancel="cancelOneStudent"
                    @on-select-all="pickAllStudent"
                    @on-select-all-cancel="cancelAllStudent"
                  >
                    <template slot="className" slot-scope="{ row }">
                      <strong>{{ row.gradeName }}{{ row.className }}</strong>
                    </template>
                  </Table>
                </div>
                <!-- 学生列表表格 end  -->
                <div class="page-box">
                  <div class="page-left">已选{{ selectList.length }}个学生</div>
                  <div class="page-content">
                    <Page
                      :total="pageInfo.total"
                      show-total
                      show-elevator
                      show-sizer
                      :page-size="pageInfo.pageSize"
                      :current="pageInfo.pageNum"
                      class="page-right"
                      :transfer="true"
                      :page-size-opts="pageSizeOpts"
                      @on-change="handlePageChange"
                      @on-page-size-change="onPageSizeChange"
                    ></Page>
                  </div>
                </div>
              </div>
              <div class="right-select">
                <div class="right-select-title">
                  选中学生({{ selectList.length }})
                </div>
                <div v-if="false">
                  <span>入班时间</span>
                  <DatePicker
                    v-if="showModal"
                    type="date"
                    :clearable="false"
                    :value="nowDate"
                    placeholder="请选择入班时间"
                    @on-change="handleGetBeginDate"
                  ></DatePicker>
                </div>
                <div class="select-block">
                  <div class="select-block-scroll">
                    <Table
                      :columns="selectColumn"
                      :data="selectList"
                      height="500"
                      border
                    >
                      <template slot="classNo" slot-scope="{ row, index }">
                        <Select
                          v-model="selectList[index]['classNo']"
                          style="width: 200px"
                          :transfer="true"
                        >
                          <Option
                            v-for="item in classTimeLists"
                            :key="item.classNo"
                            :value="item.classNo"
                            :disabled="
                              selectList[index]['isSignClassNo'].includes(
                                item.classNo
                              )
                            "
                          >{{ item.timeStr }}</Option>
                        </Select>
                      </template>
                      <template slot="action" slot-scope="{ row }">
                        <Button
                          type="error"
                          size="small"
                          @click="handleDeleteItem(row)"
                        >删除</Button>
                      </template>
                    </Table>
                    <!-- <div
                      v-for="(item, index) in selectList"
                      :key="index"
                      class="select-item"
                    >
                      <span>{{ item.studentName }}</span>
                      <Icon
                        class="close-icon"
                        :size="20"
                        type="md-close"
                        color="rgba(0,0,0,0.3)"
                        @click="handleDeleteItem(item)"
                      ></Icon>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="btn-box">
              <Button @click="close">取消</Button>
              <Button
                type="primary"
                :disabled="disabled"
                @click="handleClickSure"
                >确定</Button
              >
            </div> -->
          </div>
        </TabPane>
      </Tabs>
      <div class="footer">
        <div class="btn-box">
          <Button @click="handleActionClose">取消</Button>
          <Button
            type="primary"
            :disabled="disabled"
            @click="handleActionClickSure"
          >确定</Button>
        </div>
      </div>
    </Drawer>
    <!-- <Modal
      ref="modal"
      v-model="showModal"
      :title="modalTitle"
      :width="1300"
      :footer-hide="true"
      :closable="false"
    >

    </Modal> -->
  </div>
</template>
<script>
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import EnrollStudentModalItemNew from './EnrollStudentModal-item-new.vue';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms.vue';
import common from '@/request/common/index.js';
import { transferDate } from '@/utils/utils.js';
export default {
  components: { EnrollStudentModalItemNew, CascaderYearTerms },
  props: {
    selectStudentRow: {
      type: Object,
      default: () => { }
    },
    classroomId: {
      type: String,
      default: ''
    }, // 班级id
    relClassroomId: {
      type: String,
      default: ''
    }, // 商品id
    schoolId: {
      type: String,
      default: ''
    }, // 学校id
    termCode: {
      type: [Number, String],
      default: ''
    },
    yearCode: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      showModal: false, // 本弹窗是否展示
      tabsValue: 'name1',
      classroomIdItem: '',
      relClassroomIdItem: '',
      schoolIdItem: '',
      unCheckStuInfo: {},
      pageSizeOpts: [10, 20, 50, 100], // 每页条数
      pageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      searchFormValidate: {
        studentName: null, // 学生姓名
        classData: [], // 班级信息
        gradeId: null, // 年级
        classId: null, // 班级
        signStatus: null, // 报名状态
        studentSts: '0' // 入班状态
      }, // 搜索参数
      gradeAndClassList: [], // 年级班级列表
      signStatusList: [
        {
          label: '已报名',
          value: '1'
        },
        {
          label: '未报名',
          value: '2'
        }
      ],
      inClassStatusList: [
        {
          label: '已入班',
          value: '1'
        },
        {
          label: '未入班',
          value: '0'
        }
      ],
      selectColumn: [{
        title: '学生姓名',
        width: 140,
        key: 'studentName'
      }, {
        title: '入班节次',
        slot: 'classNo',
        width: 230
      }, {
        title: '操作',
        width: 80,
        slot: 'action'
      }],
      tableColumn: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '学生姓名',
          key: 'studentName',
          align: 'center',
          width: 150
        },
        {
          title: '学号',
          key: 'studentSort',
          align: 'center',
          minWidth: 120
        },
        // {
        //   title: '年级',
        //   key: 'gradeName',
        //   align: 'center',
        //   minWidth: 120
        // },
        {
          title: '班级',
          slot: 'className',
          align: 'center',
          width: 150
        },
        {
          title: '报名状态',
          key: 'status',
          width: 120,
          align: 'center',
          render: h => {
            return h('div', ['已报名']);
          }
        },
        {
          title: '入班状态',
          key: 'studentSts',
          align: 'center',
          width: 100,
          render: (h, params) => {
            return h('div', [
              params.row.studentSts === 1 ? '已入班' : '未入班'
            ]);
          }
        },
        {
          title: '待消课时',
          key: 'stuFinClassesTotal',
          align: 'center',
          width: 100,
          render: (h, params) => {
            return h('div', [Number(params.row.stuClassesTotal) - Number(params.row.stuFinClassesTotal)]);
          }
        }, {
          title: '已有考勤数',
          key: 'hasSignTotal',
          align: 'center',
          width: 100
        }
      ], // 学生列表表头
      studentList: [], // 学生列表数据
      selectList: [], // 已勾选的学生
      nowDate: '', // 当前日期
      intoClassDate: '', // 入班时间
      canSubmitApi: true, // 能否提交学生入班
      modalTitle: '', // 弹窗标题
      classTimeLists: [], // 课堂节次列表
      itemBtnStatus: true, // 其他课程提交按钮状态
      tableLoading: false
    };
  },
  computed: {
    // 提交数据按钮是否可以点击
    disabled() {
      if (this.tabsValue == 'name1') {
        return this.itemBtnStatus;
      } else {
        if (this.selectList.length === 0 || !this.canSubmitApi) {
          return true;
        } else {
          return false;
        }
      }
    },
    cacheYearTerms() {
      if (!this.yearCode) {
        return [];
      }
      return [+this.yearCode, this.termCode + ''];
    }
  },
  watch: {
    classroomId(newVal) {
      this.classroomIdItem = newVal;
    },
    relClassroomId(newVal) {
      this.relClassroomIdItem = newVal;
    },
    schoolId(newVal) {
      this.schoolIdItem = newVal;
    }
  },
  created() {

  },
  methods: {
    // 打开弹窗
    open() {
      this.$nextTick(() => {
        this.tabsValue = 'name2';
      });
      this.selectList = [];
      this.modalTitle = `选择学生入班-${this.selectStudentRow.classroomName}-(上课时间：${this.selectStudentRow.timeDesc})-(价格：${this.selectStudentRow.classroomFee / 100}元)`;
      this.selectStudentRow.classDateBegin ? this.getDate() : this.getToday();
      this.showModal = true;
      this.getStudentsList();
      this.getListOrgGradeClassFunc();
      this.getSearchClassroomDetail(this.classroomId);
      this.$refs.EnrollStudentModalItem.open();
    },
    // 获取课程商品节次列表
    async getSearchClassroomDetail(classroomId) {
      const portOrg = localStorage.getItem('portOrg');
      let res;

      if (portOrg == 2) {
        res = await courseSchedulCenter.getSearchClassroomDetailBySchool({ classroomId });
      } else {
        res = await courseSchedulCenter.getSearchClassroomDetail({ classroomId });
      }
      if (res.status === 200) {
        res.message.forEach(item => {
          try {
            item.timeStr = item.classTimeBegin ? `第${item.classNo}节 (${item.classTimeBegin.split(' ')[0]})` : '';
          } catch (err) {

          }
        });
        this.classTimeLists = res.message;
      }
    },
    handleStuItemNewBtnStatus(val) {
      this.itemBtnStatus = val;
      console.log(val);
    },
    // 关闭时触发
    onDrawerClose() {
      this.pageInfo = {
        total: 0,
        pageNum: 1,
        pageSize: 10
      };
      this.selectList = [];
    },
    // 关闭弹窗
    close() {
      this.onDrawerClose();
      this.showModal = false;
    },
    // 搜索报名学生
    handleSearch() {
      this.pageInfo.pageNum = 1;
      this.pageInfo.total = 0;
      // this.selectList = []
      this.getStudentsList(this.searchFormValidate);
    },
    // 重置搜索数据
    resetForm() {
      this.$refs.searchForm.resetFields();
      this.pageInfo.pageNum = 1;
      this.pageInfo.total = 0;
      // this.selectList = []
      this.getStudentsList();
    },
    // 页码 大小改变
    onPageSizeChange(size) {
      this.pageInfo.pageSize = size;
      this.pageInfo.pageNum = 1;
      this.getStudentsList();
    },
    // 点击页码
    handlePageChange(page) {
      this.pageInfo.pageNum = page;
      this.getStudentsList();
    },
    // 获取学生数据
    async getStudentsList() {
      if (this.searchFormValidate.classData.length > 0) {
        this.searchFormValidate.gradeId = this.searchFormValidate.classData[0];
        this.searchFormValidate.classId = this.searchFormValidate.classData[1];
      } else {
        this.searchFormValidate.gradeId = null;
        this.searchFormValidate.classId = null;
      }
      const params = {
        searchSignClassroomId: this.classroomId,
        classroomId: this.relClassroomId,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize
      };
      const { classData, ...searchFormParams } = this.searchFormValidate;
      const paramsData = Object.assign(searchFormParams, params, { termCode: this.termCode, yearCode: this.yearCode });
      this.tableLoading = true;
      try {
        const res = await courseSchedulCenter.getEnrollStudents(paramsData);
        if (res.status === 200) {
          // stuFinClassesTotal
          const selectArr = this.selectList;
          this.studentList = res.message.list.map(item => {
            item.classNo = Number(item.hasSignTotal) + 1;

            item._checked = false;
            if (selectArr.findIndex(item_1 => { return item_1.id == item.id; }) != -1) {
              item._checked = true;
            }
            if (item.studentSts === 1) {
              item._disabled = true;
            }
            return item;
          });
          console.log('studentList studentList', this.studentList);
          this.pageInfo.total = Number(res.message.total);
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.tableLoading = false;
      }
    },
    // 获取开课日期，用于入班时间选择框的默认展示
    getDate() {
      // console.log(transferDate(new Date()), this.selectStudentRow.classDateBegin, '===========');
      this.nowDate = this.selectStudentRow.classDateBegin.split(' ')[0];
      this.intoClassDate = this.selectStudentRow.classDateBegin;
    },
    // 获取当前日期,用于入班时间选择框的默认展示
    getToday() {
      this.nowDate = transferDate(new Date());
      this.intoClassDate = `${this.nowDate} 00:00:00`;
    },
    // 查询学校的年级和班级
    async getListOrgGradeClassFunc() {
      const params = {
        schoolId: this.schoolId
      };
      const res = await common.getListOrgGradeClass(params);
      if (res.status === 200) {
        this.gradeAndClassList = res.message;
      }
    },
    // 选择某一行
    selectRow(row, index) {
      // 如果该行是不可以点击的就不要点
      if (!row._disabled) {
        this.$refs.dataTable.toggleSelect(index);
      }
    },
    // 选择一个学生
    pickOneStudent(_, row) {
      // row.studentId
      this.handleSelectClassNo(row);

      this.selectList.push(row);
      console.log('this.selectList', this.selectList);
    },
    // 选择学生入班时间数据处理
    handleSelectClassNo(row) {
      const stuIndex = this.selectList.findIndex(item => { return item.studentId == row.studentId; });
      if (stuIndex != -1) {
        return null;
      }
      console.log(row, stuIndex, '选择一个学生---');
      // .filter(item => { return item.isSign == 1; })
      row.isSignClassNo = row.stuSignList.map(item => { return item.classNo; });
      const key = this.classTimeLists.findIndex(item => { return !row.isSignClassNo.includes(item.classNo); });
      // row.classNo = key == -1 ? 1 : this.classTimeLists[key]['classNo'];
      row.classNo = this.classTimeLists.length === row.hasSignTotal ? row.hasSignTotal : row.hasSignTotal + 1;
    },
    // 取消选择一个学生
    cancelOneStudent(_, row) {
      this.selectList = this.selectList.filter(item => {
        return row.id !== item.id;
      });
    },
    // 点击删除选择的当前学生
    handleDeleteItem(selection) {
      this.selectList = this.selectList.filter(item => {
        return selection.id !== item.id;
      });

      this.studentList = this.studentList.map(item => {
        item._checked = false;
        const target = this.selectList.find(item_1 => { return item_1.id === item.id; });
        if (target) {
          item._checked = true;
        }
        return item;
      });
    },
    // 全选学生
    pickAllStudent(selection) {
      const pickList = selection.filter(item => {
        const index = this.selectList.findIndex(x => {
          return x.id === item.id;
        });
        return index === -1;
      });
      selection.forEach(row => {
        this.handleSelectClassNo(row);
      });
      console.log('selection', selection);
      this.selectList = this.selectList.concat(pickList);
    },
    // 取消当页学生
    cancelAllStudent() {
      this.selectList = this.selectList.filter(item => {
        const index = this.studentList.findIndex(x => {
          return x.id === item.id;
        });
        return index === -1;
      });
    },
    // 获取用户选择的入班时间
    handleGetBeginDate(formatValue, type) {
      this.intoClassDate = `${formatValue} 00:00:00`;
    },
    // 点击确定按钮
    handleClickSure() {
      if (this.selectList.length > 100) {
        this.$Message.error('单次操作学生人数不得大于100人');
        return false;
      }
      const enrollInfoList = this.selectList.map(item => {
        const classTimeList = this.classTimeLists.find((item_1) => { return item_1.classNo == item.classNo; });
        let inClassTime = '';
        if (classTimeList) {
          inClassTime = classTimeList.classTimeBegin;
        }
        // studentId 修改成 enrollId
        // 值：studentId 改成取 id
        return { enrollId: item.id, inClassTime };
      });
      if (enrollInfoList && this.intoClassDate) {
        this.dispatchStudentToClass(enrollInfoList);
      }
    },
    // 学生入班
    async dispatchStudentToClass(enrollInfoList) {
      console.log(this.intoClassDate, '入班日期');
      const params = {
        classroomId: this.classroomId, // 班级id,必填
        productId: this.relClassroomId, // 商品id,必填
        enrollInfoList
      };
      this.canSubmitApi = false;
      try {
        this.$Spin.show();
        const res = await courseSchedulCenter.postStudentBindClass(params);
        this.$Spin.hide();
        if (res.status === 200) {
          this.$Message.success(res.message ? res.message : '入班成功');
          this.close();
          // this.canSubmitApi = true;
          this.$emit('refreshCurrentPageList');
          this.$emit('resetRemoveStudent');
        }
      } finally {
        this.canSubmitApi = true;
      }
    },
    handleActionClose() {
      switch (this.tabsValue) {
        case 'name1':
          this.$refs.EnrollStudentModalItem.close();
          break;
        case 'name2':
          this.close();
          break;
      }
    },
    handleActionClickSure() {
      switch (this.tabsValue) {
        case 'name1':
          this.$refs.EnrollStudentModalItem.handleClickSure();
          break;
        case 'name2':
          this.handleClickSure();
          break;
      }
    },
    refreshCurrentPageList() {
      this.$emit('refreshCurrentPageList');
    },
    resetRemoveStudent() {
      this.$emit('resetRemoveStudent');
    }
  }
};
</script>
<style lang="scss" scoped>
.tab-content {
  padding-right: 50px;
  padding-bottom: 100px;
}
.modal-content {
  display: flex;
  .left-table {
    width: 70%;
    .page-box {
      display: flex;
      justify-content: space-between;
      margin-top: 24px;
    }
  }
  .right-select {
    width: 500px;
    margin-left: 2%;
    .right-select-title {
      margin-bottom: 32px;
    }
    .select-block {
      background: rgba(0, 0, 0, 0.03);
      padding: 16px;
      /* max-height: 90vh;
      overflow-y: scroll; */
      .select-item {
        margin-bottom: 16px;
        display: flex;
        justify-content: space-between;
        .close-icon {
          display: none;
        }
        &:hover {
          .close-icon {
            display: block;
          }
        }
      }
    }
  }
}
/*  */
.search-btn {
  margin-right: 16px;
}
.footer {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 85%;
  padding: 10px 20px 20px;
  border-top: 1px solid #eee;
  background-color: #fff;
  .btn-box {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
    button + button {
      margin-left: 16px;
    }
  }
}
.term-block {
  width: 100%;
}
</style>
